import { render, staticRenderFns } from "./sale.vue?vue&type=template&id=3f86e506"
import script from "./sale.vue?vue&type=script&lang=js"
export * from "./sale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports